
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSideProps, GetServerSidePropsContext, NextPage } from 'next'
import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { useEffect } from 'react'

import { linkBuilder } from '@/components/Link/linkBuilder'
import { PriorityDetail } from '@/containers/PriorityDetail'
import { CateCity, CitiesProvider } from '@/context/Cities'
import { TenantContextProvider } from '@/context/TenantProvider'
import { TENANTS } from '@/lib/tenants/constants'
import { getTenant } from '@/lib/tenants/getTenant'
import { Tenants } from '@/lib/tenants/types'
import { getCitiesByArea } from '@/page-commons/citiesQuery'
import { fetchPriorityListing } from '@/page-commons/potentialProperties'
import { Potential_Property } from '@/types/cate-graphql-generated-types'
import { AreaDescription } from '@/types/graphql-generated-types'
import { CardDataListing, CardDataPriority } from '@/types/property-card'
import { areaParamDecoder } from '@/utils/cities-mapper'
import { extractRequestHost } from '@/utils/extractRequestHost'
import { BuyerInfo, parseBuyerInfo } from '@/utils/priority-detail-utils'
import { fetchSimilarListingsFromPriority, fetchSimilarPrioritiesFromPriority } from '@/utils/similars-helper'

type PageProps = {
  areas: AreaDescription[]
  buyerInfo: BuyerInfo | null
  cities: CateCity[]
  priority: Potential_Property
  similarListings: CardDataListing[]
  similarPriorities: CardDataPriority[]
  tenant: Tenants
}

const PriorityDetailPage: NextPage<PageProps> = ({
  areas,
  buyerInfo,
  cities,
  priority,
  similarListings,
  similarPriorities,
  tenant,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    const tenant = getTenant()
    if (buyerInfo && buyerInfo.tenant_id && buyerInfo.tenant_id !== tenant) {
      throw new Error(
        `Buyer info tenant mismatch for host ${window.location.host} and buyer info tenant ${buyerInfo.tenant_id}`
      )
    }

    if (buyerInfo && buyerInfo.tenant_id && buyerInfo.tenant_id !== tenant) {
      throw new Error(
        `Buyer info tenant mismatch for host ${window.location.host} and buyer info tenant ${buyerInfo.tenant_id}`
      )
    }
  }, [buyerInfo])

  return (
    <>
      <Head>
        <title>
          {t('priority:PriorityDetailPage_Title')} - {priority.title}
        </title>
        <meta content="noindex, nofollow" name="robots" />
      </Head>
      <TenantContextProvider tenant={tenant}>
        <CitiesProvider areas={areas} cities={cities}>
          <PriorityDetail
            buyerInfo={buyerInfo}
            cities={{ areas: areas, list: cities }}
            priority={priority}
            similarListings={similarListings}
            similarPriorities={similarPriorities}
          />
        </CitiesProvider>
      </TenantContextProvider>
    </>
  )
}

 const _getServerSideProps: GetServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const host = extractRequestHost(ctx.req)
  const tenant = getTenant(host)
  const slug = Array.isArray(ctx.params?.slug) ? [...ctx.params?.slug].reverse()[0] : ctx.params.slug
  const ref = Array.isArray(ctx.query?.ref) ? [...ctx.query?.ref][0] : ctx.query.ref
  const previewMode = Array.isArray(ctx.query?.previewMode) ? [...ctx.query?.previewMode][0] : ctx.query.previewMode
  const locale = ctx.locale as Locale

  const priority = previewMode === 'true' ? await fetchPriorityListing(slug, false) : await fetchPriorityListing(slug)
  const haveProperty = !!priority

  if (!haveProperty) {
    return {
      redirect: {
        destination: linkBuilder.housesForSale.url(ctx.locale as Locale),
        permanent: true,
      },
    }
  }

  const buyerInfo = !!ref ? parseBuyerInfo(ref) : null

  const similarListings = (await fetchSimilarListingsFromPriority(priority, locale, tenant)) as CardDataListing[]
  const similarPriorities = (await fetchSimilarPrioritiesFromPriority(priority, tenant)) as CardDataPriority[]

  const [_, priorityListingCity] = priority.city.split('/')
  const cities = await getCitiesByArea(ctx.locale, areaParamDecoder(priorityListingCity))
  const areas = cities.filter((city) => city.referenceArea === city.slug)

  if (!buyerInfo && tenant === TENANTS.ucsc) {
    throw new Error(`Missing buyer info for tenant ${tenant} not supported`)
  }

  return {
    props: {
      areas,
      buyerInfo,
      cities,
      priority,
      similarListings,
      similarPriorities,
      tenant,
    },
  }
}

export default PriorityDetailPage


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/priority/[slug]/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  